import { defineComponent } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "index",
  setup(__props) {
    return { __sfc: true };
  }
});
export {
  _sfc_main as default
};
